import { Routes, Route, Navigate } from 'react-router-dom';

import useToken from '../../common/hooks/useToken';
import useUserName from '../../common/hooks/useUserName';
import usePcode from '../../common/hooks/usePcode';
import useUserMode from '../../common/hooks/useUserMode';

import MainMenu from './mainMenu';

import LogIn from '../../components/logIn';

export default function App() {
    const { token, setToken } = useToken();
    const { setLogedUserName } = useUserName();
    const { setLoggedPCode } = usePcode();
    const { userMode, setLogedUserMode } = useUserMode();

    const logOut = () => {
        setToken('');
        setLogedUserName('');
        setLoggedPCode('');
        setLogedUserMode('');
    }

    if (userMode !== null && userMode !== undefined && userMode.length !== 0 && !userMode.startsWith("Steward")) { logOut(); }

    if (!token)
        return <LogIn setToken={setToken} setLogedUserName={setLogedUserName} setLoggedPcode={setLoggedPCode} logInType={'Steward'} logInTitle={"Steward"}
            userNamePlaceHolder={'User name'} setLogedUserMode={setLogedUserMode}/>;

    return (
        <Routes>
            <Route path={'*'} element={<Navigate to={'mainmenu'} />}></Route>
            <Route path={'mainMenu'} element={<MainMenu logOut={logOut} />}></Route>
        </Routes>
    )
}